const MIN_RISK = 200;
const riskLevelMapping = (lvl) => Math.max(lvl - MIN_RISK, 0) / 10 + 1;

/**
 * @NOTE @TODO where do these ranges come from?
 * can we have a source of truth
 * instead of hardcoding here??
 */
const ranges = [
    '0% to 1%',
    '0.25% to 2.5%',
    '1.5% to 4.5%',
    '3.5% to 6.5%',
    '5.5% to 9.5%',
    '8.5% to 12.5%',
    '11.5% to 16.5%',
    '15.5% to 20.5%',
    '19.5% to 24.5%',
    '23.5% or higher'
];

export const trpTickerOverLap = [
    'TCELX',
    'TRCLX',
    'PRELX',
    'TEIMX',
    'PRFRX',
    'TFAIX',
    'RPGAX',
    'TGAFX',
    'RPGIX',
    'TRGAX',
    'PRSNX',
    'PGMSX',
    'PRIHX',
    'TFHAX',
    'TRLAX',
    'TRRLX',
    'TRPLX',
    'TRSJX',
    'TRFKX',
    'TRROX',
    'TORFX',
    'TRRTX',
    'TTRTX',
    'TRRWX',
    'TWRRX',
    'TRFOX',
    'TOORX',
    'TRFFX',
    'TRPPX',
    'TRTFX',
    'TTOIX',
    'PRSLX',
    'RPFDX',
    'PTTFX',
    'PTKIX',
    'PRXCX',
    'TCFEX',
    'PRPIX',
    'TICCX',
    'PREMX',
    'PRXIX',
    'PRMSX',
    'PRZIX',
    'GTFBX',
    'TBGAX',
    'PRGMX',
    'PRXAX',
    'PRHSX',
    'THISX',
    'PRHYX',
    'PRHIX',
    'PRIPX',
    'TIIPX',
    'TRBFX',
    'TRLDX',
    'MDXBX',
    'TFBIX',
    'PRCIX',
    'PRXEX',
    'NJTFX',
    'TRJIX',
    'PRNYX',
    'TRYIX',
    'PRDSX',
    'TQAIX',
    'TRRFX',
    'TRPFX',
    'TRRBX',
    'TRBRX',
    'TRRDX',
    'TRPDX',
    'TRRKX',
    'TRPKX',
    'TRRMX',
    'TRPMX',
    'TRRNX',
    'TRPNX',
    'TRRIX',
    'TRPTX',
    'PRSVX',
    'PRVIX',
    'TRPBX',
    'TPPAX',
    'PRINX',
    'PRIMX',
    'PRTAX',
    'TFILX',
    'PRFSX',
    'TTSIX',
    'PRTIX',
    'PRKIX',
    'PRVAX',
    'TFBVX',
    'TRULX',
    'RCLIX',
    'TRBUX',
    'TRSTX',
    'TLDTX',
    'TLDUX'
];

export const getRiskDisclaimer = (grade) =>
    `The standard deviation range for this risk return category is ${
        ranges[grade - 1]
    }.`;

export const riskPotentialUtil = ({
    mutualFund: { riskLevel, riskLevelName, trpCode }
}) => {
    const grade = riskLevelMapping(riskLevel);

    return {
        grade,
        disclaimer: getRiskDisclaimer(grade),
        riskLevelName,
        riskLevel,
        trpCode
    };
};
